<template>
  <div class="container">
    <follow @follow="followFn"></follow>
    <header
      :class="{ ceiling: ceil }"
      :style="[zIndex ? { 'z-index': '-1' } : {}, follow ? { top: '0.5rem' } : { top: '0' }]"
    >
      <ul>
        <li
          :class="{ colorLis: navId == index }"
          :key="index"
          @click="navClick(index)"
          v-for="(item, index) in nav"
        >
          {{ item }}
        </li>
      </ul>
    </header>
    <div class="maininfo d_jump stick" id="Glide">
      <div ref="ifscroll" class="swiper-container" id="pro_pic" style="height: auto">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in bannerList" :key="index">
            <img :style="{ height: productDateils.img_path_height / 200 + 'rem' }" v-lazy="item" />
          </div>
        </div>
        <div
          class="swiper-pagination swiper-pagination-fraction"
          id="proSwiperPagination"
          v-if="
            !productDateils.video_play_url &&
            !productDateils.video_img_url &&
            bannerList &&
            bannerList.length >= 1
          "
        >
          <div class="pro_page">
            <span class="swiper-pagination-current">{{ activeIndex + 1 }}</span>
            <span class="swiper-pagination-split">/</span>
            <span class="swiper-pagination-total">{{ bannerList.length }}</span>
          </div>
        </div>
      </div>
      <div class="box-m">
        <div class="pro_price">
          <div class="xian">
            <span class="smallprice" v-if="productDateils.money != '0.00'">
              <sub>¥</sub>
              <b>
                {{
                  String(parseFloat(productDateils.money).toFixed(2)).slice(
                    0,
                    String(parseFloat(productDateils.money).toFixed(2)).indexOf('.')
                  )
                }}
              </b>
              <sup>
                {{
                  String(parseFloat(productDateils.money).toFixed(2)).slice(
                    String(parseFloat(productDateils.money).toFixed(2)).indexOf('.'),
                    String(parseFloat(productDateils.money).toFixed(2)).length
                  )
                }}
              </sup>
            </span>
            <b
              style="font-weight: 400; color: #ffb346"
              :style="{ 'font-size': productDateils.money != '0.00' ? '0.14rem' : '0.23rem' }"
            >
              {{ productDateils.money == '0.00' ? '' : '+' }}{{ productDateils.integralcount }}
              <span class="f14">金币</span>
            </b>
          </div>
          <div class="yuan">
            <span class="smallprice">
              ¥{{
                productDateils.cost_price
                  ? parseFloat(productDateils.cost_price).toFixed(2)
                  : '0.00'
              }}
            </span>
          </div>
          <div class="endTime flex-ac f12 color-FC0324" v-if="time > 0">
            距开售还剩
            <van-count-down :time="time" @finish="finish">
              <template #default="timeData">
                <span class="timeData">
                  {{
                    timeData.days * 24 + timeData.hours < 10
                      ? '0' + timeData.hours
                      : timeData.days * 24 + timeData.hours
                  }}
                </span>
                <span class="colon">:</span>
                <span class="timeData">
                  {{ timeData.minutes < 10 ? '0' + timeData.minutes : timeData.minutes }}
                </span>
                <span class="colon">:</span>
                <span class="timeData">
                  {{ timeData.seconds < 10 ? '0' + timeData.seconds : timeData.seconds }}
                </span>
              </template>
            </van-count-down>
          </div>
        </div>
        <div class="pro_tit">
          {{ productDateils.name }}
          <img
            v-if="productDateils.property === 'overseas'"
            src="../../assets/images/overseas.png"
            class="overseas"
          />
        </div>
      </div>
    </div>
    <div class="pro_actinfo box-m">
      <div class="pro_arg headers flex-js-as" @click="showparam = true">
        <van-skeleton title :row="2" :loading="loading">
          <div class="tag" style="width: auto">参数</div>
          <div class="title flex-1">
            <div class="msgitem over-ell-1" v-if="specification">{{ specification }}</div>
            <div class="msgitem over-ell-1" v-if="productDateils.item_character">
              {{ productDateils.item_character }}
            </div>
          </div>
        </van-skeleton>
        <van-icon name="arrow" color="#909090" size="0.12rem"></van-icon>
      </div>
    </div>
    <div class="pro_comment d_jump box-m pro_arg">
      <div class="pro_comment_tit flex-js-ac">
        <div class="flex-ac ht">
          {{
            productEvaluate.list && productEvaluate.list.length > 0
              ? '产品评价(' + productEvaluate.comment_nums + ')'
              : '暂无评价'
          }}
          <div class="hp ht">好评{{ productEvaluate.comment_rate }}</div>
        </div>
        <div
          class="pro_comment_more"
          @click="goCommentList"
          v-if="productEvaluate.list && productEvaluate.list.length > 0"
        >
          <div class="hp nobold">查看更多</div>
          <van-icon name="arrow" color="#FC0324" size="0.12rem"></van-icon>
        </div>
      </div>
      <div
        class="tags"
        v-if="tagslist && tagslist.length && productEvaluate.list && productEvaluate.list.length"
      >
        <ul>
          <li v-if="item" v-for="(item, index) of tagslist" :key="index">{{ item }}</li>
        </ul>
      </div>
      <div v-if="productEvaluate.list && productEvaluate.list.length > 0" class="pro_comment_list">
        <div class="pro_comment_item" v-for="(item, index) of productEvaluate.list" :key="index">
          <div class="comment_head_info" @click="commentDetail(item)">
            <div class="sj">
              <van-rate
                v-model="item.itemscore"
                :size="15"
                void-color="#eeeeee"
                void-icon="star"
                color="#FFCD07"
                readonly
              />
            </div>
            <div class="img">
              <img
                :src="item.head"
                @error="
                  (event) => {
                    let img = event.srcElement
                    img.src = errorHeadImg
                    img.onerror = null
                  }
                "
                v-if="item.head"
              />
              <img v-if="!item.head" :src="errorHeadImg" />
            </div>
            <div class="info">
              <div class="name">
                {{ item.smallname }}
                <img v-if="item.vip_level" :src="`/static/images/vipIcon/l${item.vip_level}.png`" />
              </div>
              <div class="time">{{ item.time }} 规格：{{ item.spec }}</div>
            </div>
          </div>
          <div class="comment_content_info">
            <div class="comment_txt" @click="commentDetail(item)">
              <span class="color-FC0324 f10 isfeedback" v-if="item.isfeedback">
                &nbsp;试用反馈&nbsp;
              </span>
              {{ item.content }}
            </div>
            <div class="comment_pic">
              <!-- Swiper -->
              <div class="swiper-container">
                <swiper :options="swiperOption" ref="mySwiper">
                  <swiper-slide style="position: relative" v-if="item.isvideo == 1">
                    <div style="width: 100%; height: 100%">
                      <video
                        style="width: 100%; height: 100%; object-fit: cover"
                        class="videofile"
                        id="videofile"
                        :poster="item.coverimg"
                        :src="item.videourl"
                        webkit-playsinline="true"
                        playsinline="true"
                        x5-playsinline="true"
                        x-webkit-airplay="allow"
                        preload="true"
                      >
                        <source :src="item.videourl" type="video/mp4" />
                        您的浏览器不支持 video 标签。
                      </video>
                      <img
                        style="
                          position: absolute;
                          left: 30%;
                          top: 30%;
                          width: 0.28rem;
                          height: 0.28rem;
                        "
                        @click="playFn(item.videourl)"
                        v-if="!isfullscreen"
                        src="/static/images/community/video.png"
                      />
                    </div>
                  </swiper-slide>
                  <swiper-slide v-if="item.path1">
                    <img v-lazy="item.path1" @click="preview(item, 0, 'comment')" />
                  </swiper-slide>
                  <swiper-slide v-if="item.path2">
                    <img v-lazy="item.path2" @click="preview(item, 1, 'comment')" />
                  </swiper-slide>
                  <swiper-slide v-if="item.path3">
                    <img v-lazy="item.path3" @click="preview(item, 2, 'comment')" />
                  </swiper-slide>
                  <swiper-slide v-if="item.path4">
                    <img v-lazy="item.path4" @click="preview(item, 3, 'comment')" />
                  </swiper-slide>
                  <swiper-slide v-if="item.path5">
                    <img v-lazy="item.path5" @click="preview(item, 4, 'comment')" />
                  </swiper-slide>
                  <swiper-slide v-if="item.path6">
                    <img v-lazy="item.path6" @click="preview(item, 5, 'comment')" />
                  </swiper-slide>
                </swiper>
                <!-- Add Pagination -->
                <div class="swiper-pagination"></div>
              </div>
            </div>
          </div>
          <div class="comment_oper">
            <div class="button" @click="commentLike(item)">
              <img
                :src="
                  item.islike == 0
                    ? require('../../assets/images/zan.png')
                    : require('../../assets/images/zan1.png')
                "
              />
              {{ parseInt(item.like_nums) > 0 ? item.like_nums : '点赞' }}
            </div>
            <div class="button" @click="commentDetail(item)">
              <img src="../../assets/images/ly.png" />
              {{ parseInt(item.leave_nums) > 0 ? item.leave_nums : '留言' }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="goodcomments pro_comment_list"
        v-if="goodcommentsnum > 0"
        @click="$router.push('/fansShow?showbuy=0&itemid=' + productDateils.itemid)"
      >
        <div class="pro_comment_tit flex-js-ac">
          <div class="flex-ac ht">金粉秀({{ goodcommentsnum }})</div>
          <div class="pro_comment_more">
            <div class="hp nobold">查看更多</div>
            <van-icon name="arrow" color="#FC0324" size="0.12rem"></van-icon>
          </div>
        </div>
        <div class="pro_comment_item">
          <div class="comment_content_info">
            <div class="comment_pic">
              <!-- Swiper -->
              <div class="swiper-container">
                <swiper :options="swiperOption" ref="mySwiper">
                  <swiper-slide v-for="(item, index) of goodcomments" :key="index">
                    <img
                      :src="item.path"
                      @click.stop="
                        $router.push(
                          '/commentDetail?showbuy=0&goodcomment=1&commentid=' +
                            item.commentid +
                            '&isofficia=' +
                            item.isofficia
                        )
                      "
                    />
                    <img
                      v-if="item.isvideo == 1"
                      @click.stop="
                        $router.push(
                          '/commentDetail?showbuy=0&goodcomment=1&commentid=' +
                            item.commentid +
                            '&isofficia=' +
                            item.isofficia
                        )
                      "
                      style="
                        position: absolute;
                        left: 32%;
                        top: 30%;
                        width: 0.28rem;
                        height: 0.28rem;
                      "
                      src="/static/images/community/video.png"
                    />
                  </swiper-slide>
                </swiper>
                <!-- Add Pagination -->
                <div class="swiper-pagination"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="problems goodcomments pro_comment_list"
        v-if="problemsnum >= 0"
        @click="$router.push('/askEveryone?showbuy=0&itemid=' + productDateils.itemid)"
      >
        <div class="pro_comment_tit flex-js-ac">
          <div class="flex-ac ht">问大家({{ problemsnum }})</div>
          <div class="pro_comment_more" v-if="problems.length">
            <div class="hp nobold">查看更多</div>
            <van-icon name="arrow" color="#FC0324" size="0.12rem"></van-icon>
          </div>
        </div>
        <div class="problemslist">
          <div class="flex-js-ac" v-if="!problems.length">
            <p class="f12 color-9 over-ell-1">商品好不好，问问已买过的人哦</p>
            <button class="f12 color-FC0324">去提问</button>
          </div>
          <div
            class="flex-js-ac"
            v-for="(item, index) of problems"
            :key="index"
            @click.stop="goProblemDetails(item)"
          >
            <p class="f12 over-ell-1">{{ item.question }}</p>
            <span class="f12 color-9 flex-s">{{ item.answernum }}个回答</span>
          </div>
        </div>
      </div>
    </div>
    <div class="pro_details d_jump recommend">
      <div class="pro_details_tit">产品详情</div>
      <div
        class="pro_details_con"
        v-if="!productDateils.descriptions || productDateils.descriptions.length == 0"
        v-html="productDateils.description"
      ></div>
      <div class="pro_details_con" v-else>
        <img
          v-for="(item, index) of productDateils.descriptions"
          v-lazy="item.path"
          @click="preview(item, index, 'description')"
        />
      </div>
    </div>
    <div class="pro_goods_menu">
      <div class="iconbtn">
        <div class="kefu" @click="keFu">
          <img src="../../assets/images/service.png" />
          <div class="txt">客服</div>
        </div>
      </div>
      <div
        v-if="productDateils.islimit == 0 && productDateils.issale == 1"
        :class="[productDateils.isconvert2 == 1 ? '' : 'grayexchange', 'button exchange']"
        @click="goNext"
      >
        {{ productDateils.isconvert2 == 1 ? '立即购买' : '已兑换' }}
      </div>
      <div
        v-else-if="autochangetime && productDateils.islimit == 1 && productDateils.issale == 1"
        class="button exchange"
      >
        {{ autochangetime }}
      </div>
      <div v-else-if="productDateils.islimit == 2" class="button exchange grayexchange">已售罄</div>
      <div v-else-if="productDateils.issale == 0" class="button exchange grayexchange">无货</div>
    </div>
    <div class="floatBtn">
      <img
        class="recommend"
        v-if="!headerShow"
        @click="recommend"
        src="../../assets/images/recommend.png"
      />
      <img
        class="stick"
        v-else-if="headerShow"
        @click="stick"
        src="../../assets/images/stick.png"
      />
    </div>

    <van-overlay :show="showshare" z-index="99"></van-overlay>
    <div class="sharecontainer" v-if="showshare === true">
      <img src="../../assets/images/sharemc.png" />
      <van-button round plain type="danger" class="know" @click="showshare = false">
        我知道
      </van-button>
    </div>
    <template slot="sku-header" slot-scope="props">
      <div class="van-sku-header van-hairline--bottom">
        <div class="van-sku-header__img-wrap">
          <img v-lazy="goods.picture" />
        </div>
        <div class="van-sku-header__goods-info">
          <div class="van-sku-name">{{ goods.title }}</div>
          <div class="van-sku-header-item">
            {{ skuname === '' ? '请选择商品规格' : '已选 ' + skuname }}
          </div>
          <div class="van-sku__goods-price">
            <span class="van-sku__price-symbol">¥</span>
            <span class="van-sku__price-num">{{ skuprice }}</span>
          </div>
          <i @click="showSku = false" class="van-icon van-icon-clear van-sku__close-icon"></i>
        </div>
      </div>
    </template>
    <template slot="sku-actions" slot-scope="props">
      <div class="van-sku-actions">
        <van-button @click="onConfirmClicked" class="sure" size="large" square type="danger">
          确定
        </van-button>
      </div>
    </template>
    <sku-integral
      :info="productDateils"
      @changeNumber="changeNumber"
      @closeSku="closeSku"
      v-if="showSku"
    ></sku-integral>
    <div v-if="showsVideo" class="van-uploader__wrapper">
      <div
        class="van-uploader__upload"
        :class="{ fullscreen: isfullscreen }"
        style="position: relative; width: 1.05rem; height: 1.05rem; background: #333333"
      >
        <video
          @click="playFn2"
          class="videofile"
          id="videofile2"
          :src="fullVideoUrl"
          webkit-playsinline="true"
          playsinline="true"
          x5-playsinline="true"
          x-webkit-airplay="allow"
          preload="true"
        >
          <source :src="fullVideoUrl" />
          您的浏览器不支持 video 标签。
        </video>
      </div>
    </div>
    <!--产品参数-->
    <van-action-sheet v-model="showparam" title="产品参数">
      <div class="van-action_model">
        <div class="pro_arg">
          <div class="pro_arg_list">
            <div class="pro_mess">
              <div class="pro_arg_item" v-if="productDateils.brand">
                <span>产品品牌</span>
                <span>{{ productDateils.brand }}</span>
              </div>
              <div class="pro_arg_item" v-if="specification">
                <span>产品规格</span>
                <span v-html="specification"></span>
              </div>
              <div class="pro_arg_item" v-if="productDateils.usescope">
                <span>适用范围</span>
                <span>{{ productDateils.usescope }}</span>
              </div>
              <div class="pro_arg_item" v-if="productDateils.item_character">
                <span>商品特性</span>
                <span>{{ productDateils.item_character }}</span>
              </div>
              <div class="pro_arg_item" v-if="productDateils.usemethod">
                <span>使用方法</span>
                <span>{{ productDateils.usemethod }}</span>
              </div>
              <div class="pro_arg_item" v-if="productDateils.useyear">
                <span>使用年限</span>
                <span>{{ productDateils.useyear }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="btn footerIOS">
          <van-button round type="danger" class="vanbtn" @click="showparam = false">
            完成
          </van-button>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import Swiper from 'swiper/dist/js/swiper.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import '../../assets/css/zy.media.css'
import { isWeixin, kefu, qrcodeKefuLimits, fenxiang } from '../../assets/common/js/config'
import { Rate, Divider, Overlay, Sku, ImagePreview } from 'vant'
import zymedia from '../../assets/js/zy.media'
import follow from '../common/follow'
import Vue from 'vue'
import skuIntegral from '../../components/common/skuIntegral'
Vue.use(VueAwesomeSwiper /* { default global options } */)
export default {
  name: 'productDetail',
  components: {
    [Rate.name]: Rate,
    [Divider.name]: Divider,
    [Overlay.name]: Overlay,
    [Sku.name]: Sku,
    follow,
    skuIntegral
  },
  data() {
    return {
      showSku: false,
      showshare: false,
      activeIndex: 0,
      bannerSwiper: null,
      islove: false,
      isshow: false,
      isoverseas: false, // 判断该商品是不是海外商品
      value: 5,
      propic: null,
      bannerList: [],
      headerShow: false,
      skuname: '',
      skuprice: '197.00-218.90',
      specification: '',
      follow: null,
      ceil: false,
      zIndex: false,
      navId: 0,
      skuId: null, // 总规格id 注： 传给后端的参数
      itemnum: null, // 购买数量 注：传给后端的参数
      buyType: null, // 判断点击‘加入购物袋’或‘立即购买’，0加入购物袋  1立即购买
      nav: ['商品', '详情', '推荐'],
      productEvaluate: {},
      sku: {
        tree: [],
        list: [],
        price: '1.00',
        stock_num: 227,
        collection_id: 2261,
        none_sku: false,
        hide_stock: false
      },
      goods: {
        title: '',
        picture: ''
      },
      customStepperConfig: {
        quotaText: '每次限购xxx件',
        handleOverLimit: (data) => {},
        handleStepperChange: (currentValue) => {},
        stockNum: 1999,
        stockFormatter: (stockNum) => {}
      },
      productDateils: {
        money: 0,
        cost_price: 0
      },
      tagslist: [],
      swiperOption: {
        slidesPerView: 4.2,
        spaceBetween: 7,
        observer: true,
        observeParents: true
      },
      productlist: [],
      productBannerList: [],
      num: 1, // 商品数量
      goodcommentsnum: 0,
      goodcomments: [],
      problemsnum: 0,
      problems: [],
      isfullscreen: false,
      showsVideo: false,
      fullVideoUrl: '',
      time: 0,
      loading: true,
      showparam: false,
      autochangetime: ''
    }
  },
  mounted: function () {
    let that = this
    window.scrollTo(0, 0)
    if (isWeixin()) {
      fenxiang({ path: 'integralproductdetail' })
    }
    that.getData()
    that.$nextTick(function () {
      that.bannerSwiper = new Swiper('#pro_pic', {
        autoplay: true,
        observer: true,
        observeParents: true,
        on: {
          slideChangeTransitionStart: function () {
            that.activeIndex = this.activeIndex
          }
        }
      })
      that.propic = new Swiper('.comment_pic .swiper-container', {
        slidesPerView: 3.3,
        spaceBetween: 7,
        observer: true,
        observeParents: true
      })
      window.addEventListener('scroll', that.scrollWatch)
      var videoBar = $('#Glide .swiper-slide')
      var video = videoBar.find('video')
      video.on('play', function () {
        that.bannerSwiper.autoplay.stop()
      })
      video.on('pause', function () {
        that.bannerSwiper.autoplay.start()
      })
    })
  },
  destroyed: function () {
    window.removeEventListener('scroll', this.scrollWatch)
    this.$toast.clear()
    this.$dialog.close()
    sessionStorage.removeItem('choose_coupon')
    sessionStorage.removeItem('choose_product')
  },
  methods: {
    finish: function () {
      this.autochangetime = ''
      this.getData()
    },
    followFn: function (data) {
      this.follow = data
    },
    playFn(url) {
      this.showsVideo = !this.showsVideo
      this.isfullscreen = !this.isfullscreen
      this.fullVideoUrl = url
      this.$nextTick(() => {
        if (this.isfullscreen) {
          document.getElementById('videofile2').play()
        } else {
          document.getElementById('videofile2').pause()
        }
      })
    },
    playFn2() {
      this.showsVideo = !this.showsVideo
      this.isfullscreen = !this.isfullscreen
      if (this.isfullscreen) {
        document.getElementById('videofile2').play()
      } else {
        document.getElementById('videofile2').pause()
      }
    },
    getRecommentDatas: function () {
      var recommentUrl =
        this.$ajax.getRecommendByItemInfo_URL + '?item_base_id=' + this.$route.query.itembaseid
      var that = this
      that.$customRequestAjax(recommentUrl).then((res) => {
        if (res.data.code === 200) {
          that.productlist = res.data.itemlist
          that.productBannerList = res.data.bannerList
          that.productlist.map((item) => {
            item.product_detail = 1
          })
        }
      })
    },
    preview(items, index, type) {
      var imgArr, newImgArr
      if (type == 'comment') {
        imgArr = [items.path1, items.path2, items.path3, items.path4, items.path5, items.path6]
        newImgArr = []
        imgArr.map((item) => {
          if (item && item != undefined) {
            newImgArr.push(item)
          }
        })
      } else if (type == 'banner') {
        newImgArr = this.bannerList
      } else if (type == 'description') {
        newImgArr = []
        this.productDateils.descriptions.map((item) => {
          if (item && item != undefined) {
            newImgArr.push(item.path)
          }
        })
      }
      ImagePreview({
        images: newImgArr,
        startPosition: index,
        closeOnPopstate: true
      })
    },

    productBannerFn(items) {
      window.scrollTo(0, 0)
      switch (items.ad_type) {
        case '1': // 跳转链接
          var actid = parseInt(items.activityid) ? '?actid=' + items.activityid : ''
          window.location.href = items.ad_target + actid
          break
        case '2': // 商品分类
          if (items.ad_target == 0) {
            this.$router.push({
              path: '/classification',
              query: {
                type: 'inside'
              }
            })
          } else {
            this.$store.commit('CATEGORY_ID', items.father_class_id)
            this.$store.commit('CATEGORY_SONID', items.ad_target)
            this.$router.push({
              path: '/productCategory',
              title: encodeURIComponent(items.father_class_name)
            })
          }
          break
        case '3':
          this.$router.replace({
            path: 'productdetail',
            query: {
              itemid: items.ad_target
            }
          })
          this.itemId()
          break
        case '4':
          this.$router.push('/')
          break
        case '5':
          this.$router.push('/')
          break
      }
    },
    getData: function () {
      var url = this.$ajax.getItegralItemDetail_URL
      var that = this
      var params = {
        itemid: this.$route.query.itemid
      }
      that.$customRequestAjax.post(url, params).then((res) => {
        if (res.data.code === 200) {
          that.bannerList = res.data.iteminfo.img_paths
          that.productDateils = res.data.iteminfo
          that.specification = ''
          var len = that.productDateils.sku_rule_list
          for (var i = 0; i < len.length; i++) {
            if (len[i].sku_name) that.specification += len[i].sku_name + ' '
          }
          that.loading = false
          if (that.productDateils.islimit == 1 && that.productDateils.issale == 1) {
            if (that.productDateils.autochangetime) {
              let month = new Date(that.productDateils.autochangetime * 1000).getMonth() // 月
              let day = new Date(that.productDateils.autochangetime * 1000).getDate() // 日
              let hours = new Date(that.productDateils.autochangetime * 1000).getHours() // 时
              let min = new Date(that.productDateils.autochangetime * 1000).getMinutes() // 分
              that.time = that.productDateils.autochangetime * 1000 - new Date().getTime()
              that.autochangetime = month + 1 + '月' + day + '日 ' + hours + ':' + min + '开始'
            } else {
              that.autochangetime = '待售'
              that.time = 0
            }
          } else {
            that.autochangetime = ''
            that.time = 0
          }
          var urlEval =
            that.$ajax.getCommentByItem_URL + '?item_base_id=' + that.$route.query.itembaseid
          that.$customRequestAjax(urlEval).then((res) => {
            if (res.data.code === 200) {
              that.productEvaluate = res.data
              that.tagslist = res.data.taglist
              that.goodcommentsnum = res.data.showswitch == 1 ? res.data.goodcommentsnum : -1
              that.goodcomments = res.data.goodcomments
              that.problemsnum = res.data.problemswitch == 1 ? res.data.problemsnum : -1
              that.problems = res.data.problems
              that.productEvaluate.list.map((item) => {
                item.itemscore = parseInt(item.itemscore)
              })
            }
          })
        }
      })
    },
    scrollWatch: function () {
      var scrolled =
        parseInt(document.body.scrollTop) || parseInt(document.documentElement.scrollTop)
      // 586、1063分别为第二个和第三个锚点对应的距离
      var jump1 = document.querySelectorAll('.stick')
      if (jump1[0]) {
        if (scrolled > jump1[0].clientHeight / 3) {
          this.headerShow = true
        } else if (scrolled <= jump1[0].clientHeight / 2) {
          this.headerShow = false
        }
      }
    },
    // 点击滚动
    jump: function (dom) {
      var jump = dom
      var total = jump[0].offsetTop - 54
      var distance =
        parseInt(document.body.scrollTop) || parseInt(document.documentElement.scrollTop)
      // 平滑滚动，时长500ms，每10ms一跳，共50跳
      if (total > distance) {
        smoothDown()
      } else {
        smoothUp()
      }
      function smoothDown() {
        var step = total / 10
        if (distance < total) {
          distance += step
          document.body.scrollTop = distance
          document.documentElement.scrollTop = distance
          setTimeout(smoothDown, 30)
        } else {
          document.body.scrollTop = total
          document.documentElement.scrollTop = total
        }
      }
      function smoothUp() {
        var newTotal = distance - total
        var step = newTotal / 5
        console.log(newTotal, total)
        if (distance > 0) {
          distance -= step
          document.body.scrollTop = distance
          document.documentElement.scrollTop = distance
          setTimeout(smoothUp, 30)
        } else {
          document.body.scrollTop = total
          document.documentElement.scrollTop = total
        }
      }
    },
    // 推荐
    recommend: function () {
      var that = this
      setTimeout(function () {
        that.jump(document.querySelectorAll('.recommend'))
      })
    },
    // 回到顶部
    stick: function () {
      var that = this
      setTimeout(function () {
        that.jump(document.querySelectorAll('.stick'))
      })
    },
    keFu() {
      qrcodeKefuLimits(2).then(() => {
        kefu()
      })
    },
    stretch() {
      this.isshow = !this.isshow
    },
    commentDetail(items) {
      this.$router.push({
        path: '/commentDetail',
        query: {
          commentid: items.id,
          showbuy: 0
        }
      })
    },
    share() {
      this.showshare = true
    },
    goNext() {
      if (!this.productDateils.isconvert2) {
        this.$toast(this.productDateils.remark)
        return
      } else {
        if (parseInt(this.productDateils.integralcount) > parseInt(this.$route.query.integral)) {
          this.$dialog
            .alert({
              message: '金币不足，兑换失败！',
              className: 'percen_button_alert PopupIntegral PopupSmall',
              confirmButtonColor: '#FFFCFC',
              confirmButtonText: '去赚金币',
              closeOnPopstate: false,
              showCancelButton: true,
              cancelButtonText: '知道了'
            })
            .then(() => {
              this.$router.push({
                path: '/integralTask'
              })
            })
            .catch(() => {})
        } else {
          this.showSku = true
        }
      }
    },
    changeNumber(num) {
      this.showSku = false
      this.num = num
      this.submit()
    },
    closeSku() {
      this.showSku = false
    },
    // 跳转至订单确认页
    submit() {
      let productInfo = {
        itemid: this.productDateils.itegralItemId,
        name: this.productDateils.name,
        skuid: this.productDateils.skuid,
        spec: this.productDateils.skuname,
        price: this.productDateils.money,
        integralcount: this.productDateils.integralcount * this.num,
        img_path: this.productDateils.img_main_path,
        num: this.num,
        totalprice: (this.num * this.productDateils.money).toFixed(2)
      }

      if (productInfo.integralcount <= parseInt(this.$route.query.integral)) {
        if (this.productDateils.isconvert2 == 0) {
          this.$dialog
            .alert({
              message: decodeURIComponent(this.productDateils.remark),
              className: 'percen_button_alert exchange_button_alert',
              confirmButtonColor: '#FFFCFC',
              confirmButtonText: '我知道了',
              closeOnPopstate: false
            })
            .then(function () {})
        } else {
          localStorage.setItem('productInfo', JSON.stringify(productInfo))
          this.$router.push({
            path: '/addOrderIntegral',
            query: {
              integralType: this.$route.query.integralType
            }
          })
        }
      } else {
        this.$toast('金币不足，快去赚更多的金币吧')
      }
    },
    goCommentList() {
      this.$router.push({
        path: '/commentList',
        query: {
          itemid: this.productDateils.itemid,
          showbuy: 0
        }
      })
    },
    navClick(id) {
      this.navId = id
      // 用 class="d_jump" 添加锚点
      let jump = document.querySelectorAll('.d_jump')
      let total = jump[id].offsetTop - 44
      let distance = document.documentElement.scrollTop || document.body.scrollTop
      // 平滑滚动，时长500ms，每10ms一跳，共50跳
      let step = total / 60
      if (total > distance) {
        smoothDown()
      } else {
        let newTotal = distance - total
        step = newTotal / 60
        smoothUp()
      }
      function smoothDown() {
        if (distance < total) {
          distance += step
          document.body.scrollTop = distance
          document.documentElement.scrollTop = distance
          setTimeout(smoothDown, 10)
        } else {
          document.body.scrollTop = total
          document.documentElement.scrollTop = total
        }
      }
      function smoothUp() {
        if (distance > total) {
          distance -= step
          document.body.scrollTop = distance
          document.documentElement.scrollTop = distance
          setTimeout(smoothUp, 10)
        } else {
          document.body.scrollTop = total
          document.documentElement.scrollTop = total
        }
      }
    },
    commentLike(items) {
      var url = this.$ajax.addCommentLike_URL
      var data = {}
      if (items.islike == 0) {
        data = {
          id: items.id,
          type: 1
        }
      } else if (items.islike == 1) {
        data = {
          id: items.id,
          type: 2
        }
      }
      this.$customRequestAjax.post(url, data).then((res) => {
        if (res.data.code === 200) {
          if (items.islike == 0) {
            items.islike = 1
            items.like_nums = parseInt(items.like_nums) + 1
          } else if (items.islike == 1) {
            items.islike = 0
            items.like_nums = parseInt(items.like_nums) - 1
          }
        }
      })
    },
    goProblemDetails(item) {
      this.$router.push({
        path: '/problemDetails',
        query: {
          questionid: item.questionid,
          itemid: this.productDateils.itemid,
          questionName: item.question,
          showbuy: 0
        }
      })
    }
  }
}
$(function () {
  zymedia('video', { aspectRation: 375 / 375, preload: 'auto', hideVideoControlsOnLoad: true })
})
</script>

<style scoped lang="scss">
.container {
  /*background: #fff;*/
  padding-bottom: 0.6rem;
  header {
    background: #fff;
    opacity: 0;
    transition: all 0.45s;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    z-index: 5;
    &.ceiling {
      opacity: 1;
    }
    ul {
      display: flex;
      justify-content: space-between;
      padding: 0 0.14rem;
      height: 0.4rem;
      li {
        font-size: 0.14rem;
        font-weight: 400;
        color: rgba(41, 41, 41, 1);
        line-height: 0.38rem;
        &.colorLis {
          border-bottom: 0.02rem solid #fc0324;
        }
      }
    }
  }
  .box-m {
    background: #ffffff;
    border-radius: 0.1rem;
    margin: 0.1rem 0.11rem;
    padding: 0.12rem 0.15rem 0.15rem;
    position: relative;
  }
  .maininfo {
    /*padding-bottom: .22rem;*/
    .swiper-container {
      .swiper-wrapper {
        margin: 0;
        padding: 0;
        .swiper-slide {
          padding: 0;
          margin: 0;
          img {
            width: 100%;
            display: block;
            border: 0;
            object-fit: contain;
          }
        }
      }
      #proSwiperPagination {
        font-size: 0.12rem;
        width: 0.34rem;
        color: #fff;
        position: absolute;
        left: 50%;
        margin-left: -0.17rem;
        bottom: 0.2rem;
        .pro_page {
          position: relative;
          .swiper-pagination-current {
            width: 0.12rem;
            border-radius: 0.12rem;
            position: absolute;
            top: 0;
            left: 0;
            background: #757575;
          }
          .swiper-pagination-split {
            margin-left: 0.02rem;
            margin-right: 0.02rem;
            position: absolute;
            top: 0;
            left: 0.08rem;
            height: 0.12rem;
            line-height: 0.12rem;
            margin-top: 0.01rem;
            background: #757575;
            text-align: center;
            font-size: 0.12rem;
            transform: scale(0.8);
          }
          .swiper-pagination-total {
            width: 0.12rem;
            border-radius: 0.12rem;
            position: absolute;
            top: 0;
            left: 0.14rem;
            background: #757575;
          }
        }
      }
    }
    .pro_price {
      /*margin-top: .22rem;*/
      /*margin-left: .15rem;*/
      position: relative;
      .comment {
        min-width: 0.36rem;
        position: absolute;
        right: 0.2rem;
        top: 0.04rem;
        img {
          width: 0.2rem;
          height: 0.2rem;
          margin: 0 auto;
        }
        p {
          font-size: 0.1rem;
          font-weight: 400;
          color: rgba(101, 101, 101, 1);
          line-height: 0.14rem;
          text-align: center;
          transform: scale(0.8);
        }
      }
      .posters {
        position: absolute;
        right: 0.95rem;
        top: 0.04rem;
        img {
          width: 0.2rem;
          height: 0.2rem;
          margin: 0 auto;
        }
        p {
          font-size: 0.1rem;
          font-weight: 400;
          color: rgba(101, 101, 101, 1);
          line-height: 0.14rem;
          text-align: center;
          transform: scale(0.8);
        }
      }
      .share {
        position: absolute;
        top: 0.04rem;
        right: 0.6rem;
        img {
          width: 0.2rem;
          height: 0.2rem;
          margin: 0 auto;
        }
        p {
          font-size: 0.1rem;
          font-weight: 400;
          color: rgba(101, 101, 101, 1);
          line-height: 0.14rem;
          text-align: center;
          transform: scale(0.8);
        }
      }
      .xian {
        color: #fc0324;
        font-size: 0.14rem;
        text-align: left;
        .smallprice {
          font-size: 0;
          line-height: 0.36rem;
        }
        b {
          font-size: 0.25rem;
          line-height: 0.36rem;
          font-weight: 500;
        }
        sub {
          font-weight: normal;
          font-size: 0.16rem;
          vertical-align: baseline;
        }
        sup {
          font-size: 0.14rem;
          vertical-align: baseline;
          font-weight: 500;
        }
        .bigprice {
          font-size: 0;
          line-height: 0.2rem;
          b {
            font-size: 0.21rem;
            line-height: 0.2rem;
            font-weight: 500;
          }
        }
      }
      .yuan {
        color: #6c6c6c;
        text-align: left;
        font-size: 0.12rem;
        text-decoration: line-through;
        margin-top: -0.1rem;
      }
      .endTime {
        position: absolute;
        right: 0;
        top: 0;
        background: #ffe6e6;
        border-radius: 0.04rem;
        padding: 0.07rem 0.12rem;
        .van-count-down {
          font-size: 0;
          line-height: normal;
          margin-left: 0.06rem;
        }
        .colon {
          display: inline-block;
          margin: 0 0.01rem;
          color: #fc0324;
          font-size: 0.13rem;
        }
        .timeData {
          display: inline-block;
          min-width: 0.16rem;
          height: 0.16rem;
          line-height: 0.16rem;
          color: #fff;
          font-size: 0.1rem;
          text-align: center;
          background-color: #fc0324;
          border-radius: 0.04rem;
          padding: 0 0.015rem;
        }
      }
    }
    .pro_tit {
      font-size: 0.15rem;
      line-height: 0.21rem;
      color: #292929;
      text-align: left;
      margin-top: 0.04rem;
      /*padding: 0 .15rem;*/
      font-weight: bold;
      img {
        width: 0.16rem;
        display: inline-block;
        vertical-align: middle;
        margin-left: 0.02rem;
      }
    }
  }
  .pro_actinfo {
    .headers {
      overflow: hidden;
      /*height: .44rem;*/
      /*line-height: .44rem;*/
      position: relative;
      line-height: 0.24rem;
      .tag {
        width: 0.36rem;
        height: 0.17rem;
        display: inline-block;
        color: #909090;
        font-size: 0.13rem;
        border-radius: 0.07rem;
        float: left;
        margin-right: 0.2rem;
        font-weight: bold;
      }
      .title {
        /*margin-right: 0.1rem;*/
        line-height: 0.24rem;
        font-size: 0.13rem;
        margin-right: 0.23rem;
        color: #292929;
        /*float: left;*/
        &.act {
          margin-right: 0;
          .msgitem {
            margin-right: 0.23rem;
          }
          .group {
            margin-right: 0;
          }
        }
        .msgitem {
          .van-tag {
            font-size: 0.1rem;
            padding: 0 0.02rem;
          }
        }
      }
      &.pro_arg .van-icon {
        top: 0.05rem;
      }
      img {
        float: right;
        width: 0.18rem;
      }
      .num {
        font-size: 0.12rem;
        color: #999;
      }
    }
  }
  .pro_arg {
    /*background: #fff;*/
    /*margin-top: 0.15rem;*/
    &:first-of-type {
      margin-top: 0;
    }
    .pro_arg_tit {
      font-size: 0.14rem;
      line-height: 0.2rem;
      color: #292929;
      font-weight: 500;
    }
    .pro_arg_list {
      margin: 0 0.15rem;
      font-size: 0.13rem;
      line-height: 0.18rem;
      .pro_arg_item {
        margin-top: 0.2rem;
        display: flex;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        &.certifical_arg_item {
          margin-top: 0.1rem;
          display: block;
        }
        span:nth-child(1) {
          color: #a0a0a0;
          flex-shrink: 0;
          -webkit-flex-shrink: 0;
          -moz-flex-shrink: 0;
          -ms-flex-shrink: 0;
          -o-flex-shrink: 0;
          line-height: 0.18rem;
          &.certifical_title {
            color: #3d3d3d;
          }
        }
        span:nth-child(2) {
          color: #383333;
          line-height: 0.18rem;
          margin-left: 0.2rem;
          &.certifical_desc {
            display: block;
            font-size: 0.12rem;
            margin-left: 0;
            color: #909090;
          }
        }
      }
      .pro_arg_more {
        text-align: center;
        color: #999999;
        margin-top: 0.15rem;
        display: flex;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        align-items: center;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;
        -o-align-items: center;
        justify-content: center;
        -webkit-justify-content: center;
        -moz-justify-content: center;
        -ms-justify-content: center;
        -o-justify-content: center;
        .van-icon {
          margin-left: 0.04rem;
        }
      }
    }
  }
  .pro_comment {
    /*border-top: solid .1rem #F5F5F5;*/
    /*background: #fff;*/
    /*padding: .2rem .11rem;*/
    .tags {
      ul {
        margin-top: -0.05rem;
        margin-bottom: -0.05rem;
        font-size: 0.12rem;
        li {
          width: 30%;
          height: 0.24rem;
          margin-right: 5%;
          line-height: 0.24rem;
          text-align: center;
          color: #292929;
          font-size: 0.12rem;
          border: 0.01rem solid #fcedeb;
          border-radius: 0.12rem;
          background: #fcedeb;
          margin-top: 0.1rem;
          white-space: nowrap;
          display: inline-block;
          &:last-of-type {
            margin-right: 0;
          }
        }
      }
    }
    .hp {
      color: #fc0324;
      font-size: 0.12rem;
      float: left;
      font-weight: blod;
      margin-left: 0.12rem;
      &.nobold {
        font-weight: 400;
      }
      &.ht {
        font-size: 0.13rem;
        font-weight: bold;
      }
    }
    .pro_comment_tit {
      font-size: 0.14rem;
      color: #292929;
      font-weight: bold;
      position: relative;
      /*margin: 0 0.04rem;*/
      .pro_comment_more {
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        display: -webkit-flex;
        display: -o-flex;
        display: -ms-flex;
        display: -moz-flex;
        align-items: center;
        -webkit-align-items: center;
        -o-align-items: center;
        -ms-align-items: center;
        -moz-align-items: center;
        .van-icon-arrow {
          float: left;
        }
      }
    }
    .pro_comment_item {
      margin-top: 0.15rem;
      .comment_head_info {
        position: relative;
        overflow: hidden;
        .sj {
          position: absolute;
          right: 0;
          top: 0;
          z-index: 9;
          font-size: 0.12rem;
          .van-icon-star {
            font-size: 0.13rem;
          }
        }
        .img {
          width: 0.37rem;
          float: left;
          img {
            width: 0.37rem;
            height: 0.37rem;
            border-radius: 0.37rem;
          }
        }
        .info {
          float: left;
          position: relative;
          left: 0.1rem;
          padding-bottom: 0.1rem;
          .name {
            font-size: 0.14rem;
            line-height: 0.2rem;
            /*padding-left: .1rem;*/
            width: 2rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            img {
              width: 0.32rem;
              height: 0.15rem;
              display: inline-block;
              vertical-align: middle;
              // margin-left: -.1rem;
            }
          }

          .time {
            font-size: 0.1rem;
            /*transform: scale(0.95);*/
            color: #afb0af;
            padding-top: 0.03rem;
          }
        }
      }
      .comment_content_info {
        padding-left: 0;
        .comment_txt {
          font-size: 0.14rem;
          line-height: 0.2rem;
          color: #6d6d6d;
          word-break: break-word;
          .isfeedback {
            border-radius: 0.02rem;
            border: 0.01rem solid #fc0324;
            margin-right: 0.02rem;
          }
        }
        .comment_pic {
          .swiper-container {
            width: 100%;
            height: 100%;
            .swiper-slide {
              margin-top: 0.1rem;
              border-radius: 0.08rem;
              overflow: hidden;
              text-align: center;
              font-size: 0.18rem;
              background: #fff;
              height: 0.71rem;
              display: -webkit-box;
              display: -ms-flexbox;
              display: -webkit-flex;
              display: flex;
              -webkit-box-pack: center;
              -ms-flex-pack: center;
              -webkit-justify-content: center;
              justify-content: center;
              -webkit-box-align: center;
              -ms-flex-align: center;
              -webkit-align-items: center;
              align-items: center;
              img {
                width: 100%;
                height: 100%;
                border-radius: 0.04rem;
                overflow: hidden;
                object-fit: cover;
              }
            }
          }
        }
      }
      .comment_oper {
        overflow: hidden;
        .button {
          /*border: solid 1px #606060;*/
          padding: 0.04rem 0.08rem;
          display: inline-block;
          border-radius: 0.15rem;
          font-size: 0.11rem;
          color: #6d6d6d;
          float: right;
          margin-left: 0.15rem;
          margin-top: 0.1rem;
          img {
            width: 0.16rem;
            height: 0.16rem;
            display: block;
            float: left;
            margin-right: 0.05rem;
          }
        }
      }
    }
    .goodcomments {
      position: relative;
      padding-top: 0.15rem;
      margin-top: 0.11rem;
      &:after {
        content: '';
        display: block;
        width: 100%;
        height: 0.01rem;
        background: #d8d8d8;
        position: absolute;
        top: 0;
      }
      .pro_comment_item {
        margin-top: 0.11rem;
        .comment_content_info {
          .comment_pic .swiper-container .swiper-slide {
            margin-top: 0;
          }
        }
      }
      &.problems {
        margin-top: 0.15rem;
        .problemslist {
          > div {
            line-height: 0.17rem;
            margin-top: 0.04rem;
            &:first-of-type {
              margin-top: 0.09rem;
            }
          }
          p {
            line-height: 0.17rem;
            &:before {
              content: '问';
              vertical-align: middle;
              display: inline-block;
              width: 0.12rem;
              height: 0.12rem;
              line-height: 0.12rem;
              text-align: center;
              margin-top: -0.02rem;
              margin-right: 0.04rem;
              color: #ffffff;
              font-size: 0.1rem;
              border-radius: 0.02rem;
              background: linear-gradient(180deg, #fe074a 0%, #fc0324 100%);
              background: -webkit-linear-gradient(180deg, #fe074a 0%, #fc0324 100%);
              background: -moz-linear-gradient(180deg, #fe074a 0%, #fc0324 100%);
              background: -ms-linear-gradient(180deg, #fe074a 0%, #fc0324 100%);
              background: -o-linear-gradient(180deg, #fe074a 0%, #fc0324 100%);
            }
          }
          span {
            margin-left: 0.2rem;
          }
          button {
            border-radius: 0.14rem;
            border: 0.01rem solid #fc0324;
            background: none;
            outline: none;
            padding: 0.02rem 0.12rem;
          }
        }
      }
    }
  }
  .pro_details {
    background: #fff;
    padding-bottom: 0.2rem;
    .pro_details_tit {
      font-size: 0.14rem;
      color: #292929;
      font-weight: bold;
      padding: 0.2rem 0.11rem;
      padding-bottom: 0.1rem;
    }
    .pro_details_con {
      font-size: 0.14rem;
      img {
        width: 100% !important;
        height: auto !important;
        display: block;
      }
    }
  }
  .pro_related_goods {
    border-top: solid 0.1rem #f5f5f5;
    background: #fff;
    .pro_related_goods_tit {
      width: 50%;
      margin: 0 auto;
    }
    .pro_related_list {
      padding: 0 0.11rem;
      background: #fff;
      overflow: hidden;
      display: flex;
      flex-wrap: wrap;
      .pro_item:nth-child(2n) {
        padding-left: 0.035rem;
      }
      .pro_item:nth-child(2n-1) {
        padding-right: 0.035rem;
      }
    }
  }
  .pro_goods_menu {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 0.49rem;
    background: #fff;
    z-index: 99;
    .iconbtn {
      float: left;
      padding-top: 0.09rem;
      .kefu {
        float: left;
        margin-left: 0.28rem;
        img {
          width: 0.22rem;
          height: 0.22rem;
          margin: 0 auto;
        }
        .txt {
          font-size: 0.12rem;
          text-align: center;
          transform: scale(0.75);
          color: #222222;
        }
      }
      .cart {
        float: left;
        margin-left: 0.28rem;
        img {
          width: 0.22rem;
          height: 0.22rem;
          margin: 0 auto;
        }
        .txt {
          font-size: 0.12rem;
          text-align: center;
          transform: scale(0.75);
          color: #222222;
        }
      }
    }
    .button {
      float: right;
      color: #fff;
      font-size: 0.16rem;
      line-height: 0.38rem;
      text-align: center;
      border-radius: 0.19rem;
    }
    .exchange {
      width: 2.86rem;
      margin-top: 0.06rem;
      margin-right: 0.11rem;
      background: linear-gradient(to right, #fc0324, #f63a66);
      &.grayexchange {
        background: #e3e3e3;
      }
    }
  }
  .sharecontainer {
    position: fixed;
    width: 100%;
    z-index: 100;
    height: 100%;
    left: 0;
    top: 0;
    img {
      position: absolute;
      top: 0;
      right: 0.35rem;
      width: 1.53rem;
    }
    .know {
      width: 1.09rem;
      height: 0.36rem;
      line-height: 0.36rem;
      color: #fff;
      border-color: #fff;
      background: transparent;
      position: absolute;
      bottom: 1.5rem;
      left: 50%;
      margin-left: -0.54rem;
    }
  }
  .sure {
    background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
  }
  .van-action_model {
    margin-bottom: 0.8rem;
    height: 60vh;
    overflow-y: scroll;
    &.certifical {
      height: auto;
      margin-bottom: 0.5rem;
      border-top: 0.01rem solid #efefef;
    }
    .van-item {
      margin: 0.14rem;
      .tit {
        font-size: 0.14rem;
        color: #262626;
        font-weight: 400;
        line-height: 0.23rem;
      }
      .con {
        padding-top: 0.1rem;
        line-height: 0.23rem;
        font-size: 0.14rem;
        color: #333333;
      }
    }
    .btn {
      padding: 0.14rem;
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      margin: 0;
      .vanbtn {
        color: #ffffff;
        width: 100%;
        height: 0.43rem;
        background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
        border-radius: 0.25rem;
      }
    }
  }
  .floatBtn {
    position: fixed;
    right: 0.17rem;
    bottom: 0.79rem;
    background: transparent;
    z-index: 51;
    img {
      width: 0.5rem;
      height: 0.5rem;
      border-radius: 50%;
      &:first-of-type {
        margin-bottom: 0.04rem;
      }
    }
  }
}
</style>
<style lang="scss">
.container {
  .good_sku .van-sku-row__item {
    border-radius: 0.15rem;
    font-size: 0.13rem;
    color: #5e5e5e;
    padding: 0 0.1rem;
    border: solid 1px transparent;
  }
  .good_sku .van-sku-row__item::before {
    background: #eeeff4;
  }
  .good_sku .van-sku__goods-price {
    margin-top: 0.2rem;
  }
  .good_sku .van-sku__price-symbol,
  .van-sku__price-num {
    font-size: 0.16rem;
    color: #fc0324;
    font-weight: 600;
  }
  .good_sku .van-sku-row__item--active {
    border: solid 1px #fc0324;
    background-color: #fcedeb;
    color: #fc0324;
  }
  .good_sku .van-sku-row__item-name {
    padding: 0.06rem;
  }
  .good_sku .van-sku-row__item-img {
    width: 0.2rem;
    height: 0.2rem;
  }
  .good_sku.van-popup--bottom.van-popup--round {
    border-radius: 0;
  }
  .good_sku .van-sku-row__title,
  .van-sku__stepper-title {
    padding-bottom: 0.13rem;
    font-size: 0.13rem;
    color: #333333;
    line-height: 0.18rem;
    font-weight: 600;
  }
  .good_sku .van-sku__stepper {
    border-radius: 0.13rem;
    overflow: hidden;
  }
  .good_sku .van-stepper__minus,
  .van-stepper__plus,
  .van-stepper__input {
    height: 0.22rem;
  }
  .good_sku .van-stepper__minus::before,
  .van-stepper__plus::before {
    width: 9px;
  }
  .good_sku .van-stepper__minus::after,
  .van-stepper__plus::after {
    height: 9px;
  }
  .good_sku .van-sku-row__item--disabled {
    background: #fcfcfc;
    border-radius: 0.15rem;
    border: 1px solid #eeeff4;
    color: #dedede;
    &:before {
      background: #fcfcfc;
    }
  }
  .pro_details_con {
    font-size: 0.14rem;
  }
  .pro_details_con img {
    width: 100% !important;
    height: auto !important;
  }
  .pro_details_con .ckeditor-html5-video {
    width: 100%;
  }
  .pro_details_con .ckeditor-html5-video video {
    width: 100%;
  }

  .van-uploader__wrapper,
  .poster-upload .van-uploader__input-wrapper {
    width: 100%;
    height: 0.22rem;
    position: relative;
  }
  .van-uploader__preview {
    display: none !important;
  }
  .van-uploader__upload,
  .van-uploader__preview {
    overflow: hidden !important;
    border-radius: 0.03rem !important;
    border-color: #979797;
    &.fullscreen video {
      position: fixed !important;
      left: 0 !important;
      right: 0 !important;
      top: 0 !important;
      bottom: 0 !important;
      width: 100% !important;
      height: 100% !important;
      border-width: 0 !important;
      z-index: 10000;
      background: #222222;
      .van-uploader__preview-delete:before {
        display: none !important;
      }
    }
    .videofile {
      height: 100%;
      width: auto;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
    }
  }
}

.exchange_button_alert .van-dialog__footer .van-button--large {
  padding: 0.07rem 0.2rem !important;
}
.percen_button_alert .van-dialog__footer .van-button--large {
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/integral/integralProductDetail.vue